import { render } from "./cardCoupon.vue?vue&type=template&id=20751c8e"
import script from "./cardCoupon.vue?vue&type=script&lang=js"
export * from "./cardCoupon.vue?vue&type=script&lang=js"

import "./cardCoupon.vue?vue&type=style&index=0&id=20751c8e&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__